import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import {bindActionCreators} from "redux"
import {connect} from 'react-redux'
import _ from "lodash"
import NRTFormContainer from "../../../../components/_common/_form/_containers/FormContainer"
import NRTFormInput from "../../../../components/_common/_form/FormInput"
import NRTFormStateManager from "../../../../components/_common/_form/FormStateManager"
import NRTHorizontalStack from "../../../../components/_common/_containers/HorizontalStack"
import NRTButton from "../../../../components/_common/_buttons/Button"
import {PaymentMethodsEnum} from "../../../../enums/PaymentMethodsEnum"
import NRTSaleActionBar from "../../../../components/_sale/ActionButtonBar"
import BackButton from "../../../../components/_common/_buttons/BackButton"
import SalePrice from "../../../../helpers/sale-price"
import SaleRequests from "../../../../requests/sale-requests"
import {PaymentPartnersEnum} from "../../../../enums/PaymentPartnersEnum"
import FormCardInfo from "./_components/FormCardInfo"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"
import {FORM_CARD_INFO_NAME} from "./_components/FormCardInfo/reducer"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"
import Currency from "../../../../components/_common/Currency"
import axios from 'axios';

const validCard = require('card-validator')

const SIMULATE_VALIDATE_VOUCHER_ERROR = false

export class PaymentStep extends Component {

    static URL_IP_SEARCH = 'https://api.ipify.org?format=json'

    preventNewSell = false

    state = {
        form: {},
        installmentsCount: 1,
        voucher: {},
        paymentMethod: null,
        salePrice: null,
        maxInstallments: 1,
        awaitingSell: false,
        pagSeguroEnabled: false,
        payPalEnabled: false,
    }

    componentDidMount() {

        const {price} = this.props.context.saleRelease
        const {salePayment} = this.props.context
   
        const {
            sightValue,
            installmentInterest,
            maxInstallments

        } = price

        this.maxInstallments = maxInstallments
        const parameterMaxInstallments = this.props.context.systemParams.filter(s=> s.parameterId === 'PARAM_CENTRAL_BANKBILLET_MAXINSTALLMENTS')[0]

        this.maxInstallmentsBankBillet = null
        if (!!parameterMaxInstallments) {
            this.maxInstallmentsBankBillet = parameterMaxInstallments.parameterValue
        }
        if(salePayment !== null){
            this.setState({installmentsCount: salePayment.installmentNumber})
        }

        

        this.setState({
            maxInstallments: (!!this.maxInstallmentsBankBillet) ? +this.maxInstallmentsBankBillet : this.maxInstallments,
            salePrice: new SalePrice(sightValue, installmentInterest),
            saleRelease: this.props.context.saleRelease,
            bankBilletEnabled: this.props.context.saleBankBilletEnabled,
            ipagEnabled: this.props.context.salePaymentPartnerCode === PaymentPartnersEnum.IPAG.code + '',
            pagSeguroEnabled: this.props.context.salePaymentPartnerCode === PaymentPartnersEnum.PAGSEGURO.code + '',
            payPalEnabled: this.props.context.salePaymentPartnerCode === PaymentPartnersEnum.PAYPAL.code + '',
        })
       
    }

  
    callVoucherValidation = () => {

        const voucher = _.get(this.state, 'form.values.voucher', '')

        if (!voucher)
            return null

        const req = SIMULATE_VALIDATE_VOUCHER_ERROR ?
            Promise.reject() : SaleRequests.validateVoucher(voucher, this.state.saleRelease.code)

        req
            .then((voucher) => {


                if (!voucher.discountType || !voucher.discountValue) {

                    this.props.context.set({
                        toastMessage: {
                            type: 'warning',
                            content: "O cupom inserido não é válido",
                        }
                    })


                } else {

                    this.props.context.set({
                        toastMessage: {
                            type: 'success',
                            content: "Cupom de desconto aplicado com sucesso!",
                        }
                    })


                    this.setState({voucher})
                }


            })
            .catch(err => {
                console.error(err)
                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: "Ocorreu um erro ao tentar aplicar o cupom.",
                    }
                })

                this.props.context.logError(err)
            })

    }

    getInstallmentPrice(installmentNumber) {

        const {
            salePrice,
            voucher
        } = this.state

        const value = installmentNumber === 1 ? salePrice.sightValue : salePrice.valueWithInterest
        const discountValue = this.getDiscountValue(value, voucher)

        return (value * this.getNumberOfGuests() - discountValue) / installmentNumber
    }

    getNumberOfGuests() {
        return this.props.context.saleGuests.length
    }

    getDiscountValue(value, voucher) {
        if (!voucher.discountType)
            return 0
        return (voucher.discountType === 1) ? (voucher.discountValue * value) : voucher.discountValue || 0
    }

    getSaleFullValue() {

        const {
            salePrice,
            installmentsCount,
            pagSeguroEnabled,
            paymentMethod,
            payPalEnabled,
        } = this.state

        const valueWithInterest = (salePrice.valueWithInterest * this.getNumberOfGuests()).toFixed(2)
        const sightValue = (salePrice.sightValue * this.getNumberOfGuests()).toFixed(2)

        if ((pagSeguroEnabled || payPalEnabled) && paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code) {
            return valueWithInterest
        }

        if (installmentsCount === 1) {
            return sightValue
        } else {
            return valueWithInterest
        }


    }

    _finishPaymentStep = async () => {

        const {paymentMethod, ipagEnabled} = this.state

        if (paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code && ipagEnabled) {
            await this.doSaleWithIpag()

        } else {
            this.goToConfirmationStep()
        }
    }

    finishPaymentStep = _.debounce(this._finishPaymentStep, 200)

    getSalePaymentData() {
        const {
            salePrice,
            installmentsCount,
            paymentMethod,
            pagSeguroEnabled,
            payPalEnabled,
            voucher,
        } = this.state

        const _installmentsCount = (pagSeguroEnabled || payPalEnabled) ? 1 : installmentsCount

        return {
            saleValue: this.getSaleFullValue(),
            unitValue: _installmentsCount === 1 ? salePrice.sightValue : salePrice.valueWithInterest,
            installmentNumber: installmentsCount,
            installmentValue: this.getInstallmentPrice(installmentsCount),
            voucherName: voucher.name,
            paymentMethod,
            discountValue: this.getDiscountValue(this.getSaleFullValue(), voucher),
            pagSeguro: pagSeguroEnabled,
            paypal: payPalEnabled,

        }
    }

    goToConfirmationStep = () => {

        this.props.context.set({
                salePayment: this.getSalePaymentData()
            },
            () => this.props.goToNextStep()
        )
    }

    getCurrentIp = async () => {

        return new Promise(async (resolve, reject) => {

            axios({
                method: 'get',
                url: PaymentStep.URL_IP_SEARCH,
                responseType:'json'
            })
                .then(response => response.data)
                .then(function (data) {
                    console.log('STP Ip search data: ', data)
                    resolve(data.ip || '')
                })
                .catch(function (error) {
                    console.log('STP FALURE: Ip search...')
                    reject(error)
                })
        })
    }

    doSaleWithIpag = async () => {

        if (this.preventNewSell || !this.props.formCard.valid)
            return

        this.preventNewSell = true
        this.setState({awaitingSell: true})

        try {

            // Prepara callback que efetua venda no sistema nerit
            const {saleBuyer, saleRelease, saleGuests, saleResponsible} = this.props.context
            const salePaymentData = this.getSalePaymentData()

            const doSaleFunc = () => this.props.doSale({
                saleResponsible,
                saleBuyer,
                saleRelease,
                saleGuests,
                saleValue: salePaymentData.saleValue,
                unitValue: salePaymentData.unitValue,
                installmentNumber: salePaymentData.installmentNumber,
                voucherName: salePaymentData.voucherName,
                paymentMethod: salePaymentData.paymentMethod,
                paymentPartner: PaymentPartnersEnum.IPAG.code
            })

            // Parametriza venda com ipag
            const ipagConfig = await Promise.all([
                this.props.getIpagId(),
                this.props.getIpagApiKey(),
            ])

            const cardCompany = validCard.number(this.props.formCard.values.number).card.type
            const ipagEndpoint = 'https://sandbox.ipag.com.br'
            const formCard = this.props.formCard.values
            const cardNumber = formCard.number
            const cardCVV = formCard.cvc
            const cardMonth = formCard.validThru.split('/')[0]
            const cardYear = formCard.validThru.split('/')[1]
            const cardHolder = formCard.holderName

            // Executa venda com Ipag
            const result = await this.props.doPaymentWithIpag(
                doSaleFunc,
                this.props.approveSale,
                this.props.cancelSale,
                await this.getCurrentIp(),
                {
                    ipagId: _.get(ipagConfig[0], 'parameterValue'),
                    ipagApiKey: _.get(ipagConfig[1], 'parameterValue'),
                    ipagEndpoint,
                    cardHolder,
                    cardCompany,
                    cardNumber,
                    cardMonth,
                    cardYear,
                    cardCVV,
                    saleBuyer,
                    saleValue: salePaymentData.saleValue - salePaymentData.discountValue,
                    installmentNumber: salePaymentData.installmentNumber,
                }
            )

            this.onIpagSaleSuccess()

        } catch (e) {
            console.error(e)
            this.onError(e + '')
        }
    }

    onIpagSaleSuccess() {
        this.props.context.set({
            saleConfirmed: true
        }, () => {
            this.props.goToNextStep()
        })

    }

    onError = (errorMsg) => {


        this.preventNewSell = false

        this.setState({
            awaitingSell: false
        })

        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: errorMsg
            }
        })
    }

    onFormChange = (form) => {this.setState({form})}

    onInstallmentsCountChange = (iptName, iptValue) => {
        this.setState({installmentsCount: iptValue})
    }

    onPaymentMethodChange = (iptName, methodCode) => {

        let maxInstallments = this.maxInstallments

        if (methodCode === PaymentMethodsEnum.BANK_BILLET.code && !!this.maxInstallmentsBankBillet)
            maxInstallments = +this.maxInstallmentsBankBillet

        this.setState({
            installmentsCount: 1,
            paymentMethod: methodCode,         
            maxInstallments,
        })
    }

    render() {

        const {
            salePrice,
            maxInstallments,
            installmentsCount,
            voucher,
            saleRelease,
            bankBilletEnabled,
            ipagEnabled,
            pagSeguroEnabled,
            payPalEnabled,
            paymentMethod,
            awaitingSell,
        } = this.state

        const {formCard} = this.props

        if (!salePrice || !saleRelease)
            return null


        const payingWithCreditCard =  paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code
        const payingWithIpag = (ipagEnabled && payingWithCreditCard)


        const discountValue = this.getDiscountValue(
            installmentsCount === 1 ? salePrice.sightValue : salePrice.valueWithInterest,
            voucher
        )

        const paymentOptions = [
            {
                value: PaymentMethodsEnum.CREDIT_CARD.code,
                display: PaymentMethodsEnum.CREDIT_CARD.name
            }
        ]

        if (bankBilletEnabled) {
            paymentOptions.unshift({
                value: PaymentMethodsEnum.BANK_BILLET.code,
                display: PaymentMethodsEnum.BANK_BILLET.name
            })
        }

        return (

            <NRTFormStateManager
                ref={f => this.form = f}
                onStateChange={this.onFormChange}
            >

                <MCLoadingOverlay show={awaitingSell}/>
                {/*Pagamento*/}
                <BackButton onClick={this.props.goToPreviousStep}/>

                <NRTFormContainer title={'Forma de pagamento'}>

                    <div className={'payment-form-container'}>
                        <div className="payment-method">

                            <NRTVerticalStack>
                                <NRTFormInput
                                    type={'radiogroup'}
                                    name={'payment-option'}
                                    label={'Escolha a forma de pagamento'}
                                    value={this.state.paymentMethod}
                                    onChange={this.onPaymentMethodChange}
                                    customProps={{
                                        options: paymentOptions
                                    }}
                                />


                                {
                                    maxInstallments !== null &&
                                    !((pagSeguroEnabled || payPalEnabled) && payingWithCreditCard) &&  //desabilita parcelas usando pagseguro ou paypal
                                    <NRTFormInput
                                        type={'select'}
                                        name={'parcelas'}
                                        label={'Número de parcelas'}
                                        value={this.state.installmentsCount}
                                        customProps={{
                                            options: (() => {

                                                const installmentOptions = []

                                                for (let i = 1; i <= maxInstallments; i++) {


                                                    const installmentPrice = this.getInstallmentPrice(i).toFixed(2)

                                                    installmentOptions.push({
                                                        value: i,
                                                        label: `${i}x de R$ ${installmentPrice}`
                                                    })
                                                }

                                                return installmentOptions
                                            })()
                                        }}
                                        onChange={this.onInstallmentsCountChange}
                                    />

                                    

                                }

                                {
                                     payingWithCreditCard && pagSeguroEnabled &&
                                                    <p style={{fontSize: '.9rem'}}>
                                                        *Você poderá escolher o número de parcelas junto ao PagSeguro.
                                                    </p>
                                }
                                {                   
                                     payingWithCreditCard && payPalEnabled &&
                                                    <p style={{fontSize: '.9rem'}}>
                                                        *Você poderá escolher o número de parcelas junto ao PayPal.
                                                    </p> 
                                                                  
                                }


                                {/*Voucher*/}
                                <NRTHorizontalStack
                                    fractions={[3, 1]}
                                    style={{
                                        alignItems: 'flex-end',
                                        marginTop: '1.3rem'
                                    }}
                                >
                                    <NRTFormInput
                                        name={'voucher'}
                                        label={'Cupom de desconto'}
                                        defaultValue={''}
                                    />

                                    <NRTButton
                                        onClick={this.callVoucherValidation}
                                        secondary
                                        content={'Verificar'}
                                        style={{height: '2.9rem'}}
                                    />
                                </NRTHorizontalStack>


                                {/*Valores*/}
                                <NRTVerticalStack style={{marginTop: '1.5rem'}}>
                                    <div className={"payment-values"}>

                                        {/*desconto*/}
                                        {
                                            (discountValue > 0) &&
                                            <p>
                                                <b>Desconto:</b>
                                                R$ {discountValue.toFixed(2)}
                                            </p>
                                        }

                                        {
                                            (installmentsCount > 1) &&
                                            <p>
                                                {/*(downPayment > 0) && <b>+</b>*/}
                                                {installmentsCount}
                                                X de R$ {this.getInstallmentPrice(installmentsCount).toFixed(2)}
                                            </p>
                                        }

                                        <div style={{
                                            marginTop: '.5rem',
                                            padding: '1rem 0',
                                            borderTop: '1px solid #bbb',

                                        }}>
                                            <h2 style={{fontSize: '1.4rem'}}>
                                                Total: <Currency
                                                value={(this.getSaleFullValue() - discountValue).toFixed(2)}/>
                                            </h2>
                                        </div>
                                    </div>
                                </NRTVerticalStack>
                            </NRTVerticalStack>
                        </div>

                        <div className="form-card">
                            {
                                (
                                    ipagEnabled &&
                                    this.state.paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code
                                )
                                &&
                                <FormCardInfo/>
                            }
                        </div>

                    </div>


                </NRTFormContainer>


                <NRTSaleActionBar onClick={() => this.finishPaymentStep()}
                                  buttonLabel={payingWithIpag ? 'CONFIRMAR' : 'AVANÇAR'}
                                  disabled={paymentMethod === null || (payingWithIpag && formCard.valid === false)}

                />

            </NRTFormStateManager>
        )
    }
}

PaymentStep.propTypes = {
    context: PropTypes.object.isRequired,
    goToNextStep: PropTypes.func.isRequired,
    getIpagId: PropTypes.func.isRequired,
    getIpagApiKey: PropTypes.func.isRequired,
    doSale: PropTypes.func.isRequired,
    doPaymentWithIpag: PropTypes.func.isRequired,
    approveSale: PropTypes.func.isRequired,
    cancelSale: PropTypes.func.isRequired,
}

PaymentStep.defaultProps = {}

const mapStateToProps = (state) => {
    return {
        formCard: state[FORM_CARD_INFO_NAME]
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PaymentStep)



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/PaymentStep/index.js